module.exports = __webpack_public_path__ + "static/media/fire.e93f4cde.png";